module.exports = __webpack_public_path__ + "static/media/clubs_8.4d8ef6a7.png";